import script from "./SystemAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./SystemAlert.vue?vue&type=script&setup=true&lang=js"

import "./SystemAlert.vue?vue&type=style&index=0&id=66f2bbe6&lang=scss&scoped=true"
import "./SystemAlert.vue?vue&type=style&index=1&id=66f2bbe6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66f2bbe6"]])

export default __exports__